(function (win, $) {
  'use strict';
  const NAMESPACE = '.readMoreToggle';

  function isOverflowing(el) {
    return el && (el.scrollHeight > el.clientHeight + 1);
  }

  function buildButtons($box, labels) {
    let $plus = $box.children('.toggleBtn');
    let $minus = $box.children('.toggleInline');

    if (!$plus.length) {
      $plus = $('<button type="button" class="toggleBtn" aria-expanded="false">')
        .append(
          $('<span class="pm-icon" aria-hidden="true">').text('＋'),
          $('<span class="VisuallyHidden">').text(labels.openLabel)
        );
      $box.append($plus);
    }
    if (!$minus.length) {
      $minus = $('<button type="button" class="toggleInline" aria-expanded="true" hidden>')
        .append(
          $('<span class="pm-icon" aria-hidden="true">').text('−'),
          $('<span class="VisuallyHidden">').text(labels.closeLabel)
        )
        .hide();
      $box.children('.content').first().after($minus);
    }
    return { $plus, $minus };
  }

  function initReadMoreToggle(selector, options) {
    const opts = $.extend({ openLabel: '続きを読む', closeLabel: '閉じる' }, options || {});
    const $boxes = $(selector);
    if (!$boxes.length) return;

    $boxes.each(function () {
      const $box = $(this);
      const $text = $box.find('.content').first();
      if (!$text.length) return;
      if ($box.data('readmore-initialized')) return;

      const needToggle = isOverflowing($text.get(0));
      if (!needToggle) {
        $box.children('.toggleBtn,.toggleInline').remove();
        $box.data('readmore-initialized', true);
        return;
      }

      const { $plus, $minus } = buildButtons($box, opts);
      $text.removeClass('is-expanded');
      $plus.attr('aria-expanded', 'false').prop('hidden', false).show();
      $minus.attr('aria-expanded', 'true').prop('hidden', true).hide();

      $box.data('readmore-initialized', true);
    });

    // ＋ → 展開
    $(document)
      .off('click' + NAMESPACE, '.readMore1 .toggleBtn, .readMore2 .toggleBtn, .readMore3 .toggleBtn, .readMore4 .toggleBtn')
      .on('click' + NAMESPACE, '.readMore1 .toggleBtn, .readMore2 .toggleBtn, .readMore3 .toggleBtn, .readMore4 .toggleBtn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $box = $(this).closest('[class*=readMore]');
        const $text = $box.find('.content').first();
        const $minus = $box.children('.toggleInline').first();
        $text.addClass('is-expanded');
        $(this).attr('aria-expanded', 'true').prop('hidden', true).hide();
        $minus.attr('aria-expanded', 'true').prop('hidden', false).show();
      });

    // − → 再クランプ
    $(document)
      .off('click' + NAMESPACE, '.readMore1 .toggleInline, .readMore2 .toggleInline, .readMore3 .toggleInline, .readMore4 .toggleInline')
      .on('click' + NAMESPACE, '.readMore1 .toggleInline, .readMore2 .toggleInline, .readMore3 .toggleInline, .readMore4 .toggleInline', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $box = $(this).closest('[class*=readMore]');
        const $text = $box.find('.content').first();
        const $plus = $box.children('.toggleBtn').first();
        $text.removeClass('is-expanded');
        $(this).attr('aria-expanded', 'false').prop('hidden', true).hide();
        $plus.attr('aria-expanded', 'false').prop('hidden', false).show();
      });

    const refresh = function () {
      $(selector).each(function () {
        const $box = $(this);
        const $text = $box.find('.content').first();
        if (!$text.length) return;
        const expanded = $text.hasClass('is-expanded');
        const overflowNow = isOverflowing($text.get(0));
        const $plus = $box.children('.toggleBtn');
        const $minus = $box.children('.toggleInline');

        if (expanded) {
          if ($minus.length) $minus.prop('hidden', false).show();
          if ($plus.length) $plus.prop('hidden', true).hide();
        } else {
          if (!overflowNow) {
            $plus.prop('hidden', true).hide();
            $minus.prop('hidden', true).hide();
          } else {
            $plus.prop('hidden', false).show();
            $minus.prop('hidden', true).hide();
          }
        }
      });
    };

    let t = null;
    $(win).off('resize' + NAMESPACE).on('resize' + NAMESPACE, function () {
      clearTimeout(t); t = setTimeout(refresh, 120);
    });

    win.readMoreToggle = win.readMoreToggle || {};
    win.readMoreToggle.refresh = refresh;
  }

  // 初期化
  $(function () {
    initReadMoreToggle('.readMore1, .readMore2, .readMore3, .readMore4');
  });
  win.initReadMoreToggle = initReadMoreToggle;

})(window, window.jQuery);












/**
 * 最初のP以降を折りたたむ「続きを読む」トグル
 *
 * 使い方：
 * <div class="loadMore">
 *  <p>最初の段落</p>
 *  <p>2つ目以降の段落</p>
 *  ...
 * </div>
 *
 * 1. .loadMore クラスを付与した要素に対して動作します。
 * 2. textBodyと併用できます
 */
(function (win, $) {
  'use strict';
  const NAMESPACE = '.loadMoreToggle';

  // ＋続きを読む／－閉じるのリンクを生成（同じラッパー内に格納）
  function buildButtons($box, labels) {
    let $wrap = $box.children('.toggleWrapper');
    let $plus = $wrap.find('.toggleBtn');
    let $minus = $wrap.find('.toggleInline');

    if (!$wrap.length) {
      $wrap = $('<div class="toggleWrapper"></div>');
      $box.append($wrap);
      //console.log('[loadMore] toggleWrapper を追加');
    }

    if (!$plus.length) {
      $plus = $('<a href="javascript:void(0);" class="toggleBtn" role="button" aria-expanded="false">＋続きを読む</a>');
      // SR向け補足（任意）
      $plus.append($('<span class="VisuallyHidden">').text(labels.openLabel || '続きを読む'));
      $wrap.append($plus);
      //console.log('[loadMore] ＋続きを読む リンクを追加');
    }

    if (!$minus.length) {
      $minus = $('<a href="javascript:void(0);" class="toggleInline" role="button" aria-expanded="true" hidden>－閉じる</a>').hide();
      // SR向け補足（任意）
      $minus.append($('<span class="VisuallyHidden">').text(labels.closeLabel || '閉じる'));
      $wrap.append($minus);
      //console.log('[loadMore] －閉じる リンクを追加');
    }

    return { $wrap, $plus, $minus };
  }

  // 初期化
  function initLoadMoreToggle(selector, options) {
    const opts = $.extend({ openLabel: '続きを読む', closeLabel: '閉じる' }, options || {});
    const $boxes = $(selector);
    if (!$boxes.length) {
      //console.log('[loadMore] 対象が見つかりません');
      return;
    }

    $boxes.each(function () {
      const $box = $(this);
      if ($box.data('loadmore-initialized')) return;

      // 初期状態は折りたたみ（CSS側で p の表示を制御）
      $box.removeClass('is-expanded');

      // ボタン生成（同じラッパーに入れることで右寄せを一貫）
      const { $wrap, $plus, $minus } = buildButtons($box, opts);

      // 初期表示：＋のみ表示、－は隠す
      $plus.attr('aria-expanded', 'false').prop('hidden', false).show();
      $minus.attr('aria-expanded', 'true').prop('hidden', true).hide();

      //console.log('[loadMore] 初期化完了', $box.get(0));
      $box.data('loadmore-initialized', true);
    });

    // 展開：＋クリック
    $(document)
      .off('click' + NAMESPACE, '.loadMore .toggleBtn')
      .on('click' + NAMESPACE, '.loadMore .toggleBtn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $box = $(this).closest('.loadMore');
        const $wrap = $box.children('.toggleWrapper');
        const $plus = $wrap.find('.toggleBtn');
        const $minus = $wrap.find('.toggleInline');

        // 展開はクラスで制御（CSSが本文表示を担保）
        $box.addClass('is-expanded');

        // ボタンの表示切替
        $plus.attr('aria-expanded', 'true').prop('hidden', true).hide();
        $minus.attr('aria-expanded', 'true').prop('hidden', false).show();

        //console.log('[loadMore] 展開', $box.get(0));
      });

    // 折りたたみ：－クリック
    $(document)
      .off('click' + NAMESPACE, '.loadMore .toggleInline')
      .on('click' + NAMESPACE, '.loadMore .toggleInline', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $box = $(this).closest('.loadMore');
        const $wrap = $box.children('.toggleWrapper');
        const $plus = $wrap.find('.toggleBtn');
        const $minus = $wrap.find('.toggleInline');

        // 折りたたみはクラスで制御（CSSが「最初のpだけ表示」を担保）
        $box.removeClass('is-expanded');

        // ボタンの表示切替
        $minus.attr('aria-expanded', 'false').prop('hidden', true).hide();
        $plus.attr('aria-expanded', 'false').prop('hidden', false).show();

        //console.log('[loadMore] 折りたたみ', $box.get(0));
      });

    // リサイズ時の再調整（必要があればフック）
    let t = null;
    $(win).off('resize' + NAMESPACE).on('resize' + NAMESPACE, function () {
      clearTimeout(t);
      t = setTimeout(function () {
        // 右寄せは .toggleWrapper の text-align で常に維持されるため特に処理不要
        //console.log('[loadMore] resize refresh');
      }, 120);
    });

    // 外部から再初期化したい場合用
    win.loadMoreToggle = win.loadMoreToggle || {};
    win.loadMoreToggle.refresh = function () {
      $('.loadMore').each(function () {
        const $box = $(this);
        const $wrap = $box.children('.toggleWrapper');
        const $plus = $wrap.find('.toggleBtn');
        const $minus = $wrap.find('.toggleInline');
        if ($box.hasClass('is-expanded')) {
          $plus.hide().prop('hidden', true);
          $minus.show().prop('hidden', false);
        } else {
          $minus.hide().prop('hidden', true);
          $plus.show().prop('hidden', false);
        }
      });
      //console.log('[loadMore] manual refresh');
    };
  }

  // DOM Ready
  $(function () {
    //console.log('[loadMore] 起動');
    initLoadMoreToggle('.loadMore');
  });

  // 外から再実行したい用
  win.initLoadMoreToggle = initLoadMoreToggle;

})(window, window.jQuery);


/*!
 * SP-only LoadMore（768px以下のみ有効）
 * 使い方：
 * <div class="SP-loadMore">
 *   <p>最初の段落</p>
 *   <p>2つ目以降…</p>
 * </div>
 *
 * ・768px以下：最初の<p>以外を折りたたみ、＋続きを読む／－閉じるを表示
 * ・769px以上：常にすべて表示。トグルUIはDOMから除去（クリーンアップ）
 */
(function (win, $) {
  'use strict';
  const NAMESPACE = '.spLoadMoreToggle';
  const MOBILE_MAX = 768;
  const mq = win.matchMedia(`(max-width: ${MOBILE_MAX}px)`);

  function isMobile() {
    return mq.matches;
  }

  function buildButtons($box, labels) {
    let $wrap = $box.children('.toggleWrapper');
    let $plus = $wrap.find('.toggleBtn');
    let $minus = $wrap.find('.toggleInline');

    if (!$wrap.length) {
      $wrap = $('<div class="toggleWrapper"></div>');
      $box.append($wrap);
    }
    if (!$plus.length) {
      $plus = $('<a href="javascript:void(0);" class="toggleBtn" role="button" aria-expanded="false">＋続きを読む</a>');
      $plus.append($('<span class="VisuallyHidden">').text(labels.openLabel || '続きを読む'));
      $wrap.append($plus);
    }
    if (!$minus.length) {
      $minus = $('<a href="javascript:void(0);" class="toggleInline" role="button" aria-expanded="true" hidden>－閉じる</a>').hide();
      $minus.append($('<span class="VisuallyHidden">').text(labels.closeLabel || '閉じる'));
      $wrap.append($minus);
    }
    return { $wrap, $plus, $minus };
  }

  function teardownOne($box) {
    // PC幅ではトグルを撤去し、常に全段落表示へ
    $box.removeClass('is-expanded');
    const $wrap = $box.children('.toggleWrapper');
    if ($wrap.length) $wrap.remove();
  }

  function initOne($box, opts) {
    if ($box.data('sp-loadmore-initialized')) return;

    // SP幅：初期状態は折りたたみ
    $box.removeClass('is-expanded');

    const { $plus, $minus } = buildButtons($box, opts);
    $plus.attr('aria-expanded', 'false').prop('hidden', false).show();
    $minus.attr('aria-expanded', 'true').prop('hidden', true).hide();

    $box.data('sp-loadmore-initialized', true);
  }

  function destroyOne($box) {
    // データフラグを戻し、UIを撤去
    $box.removeData('sp-loadmore-initialized');
    teardownOne($box);
  }

  function bindHandlers() {
    // 展開（SP時のみ意味を持つ／PCではUI自体がない）
    $(document)
      .off('click' + NAMESPACE, '.SP-loadMore .toggleBtn')
      .on('click' + NAMESPACE, '.SP-loadMore .toggleBtn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isMobile()) return; // 念のため

        const $box = $(this).closest('.SP-loadMore');
        const $wrap = $box.children('.toggleWrapper');
        const $plus = $wrap.find('.toggleBtn');
        const $minus = $wrap.find('.toggleInline');

        $box.addClass('is-expanded');
        $plus.attr('aria-expanded', 'true').prop('hidden', true).hide();
        $minus.attr('aria-expanded', 'true').prop('hidden', false).show();
      });

    // 折りたたみ
    $(document)
      .off('click' + NAMESPACE, '.SP-loadMore .toggleInline')
      .on('click' + NAMESPACE, '.SP-loadMore .toggleInline', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isMobile()) return;

        const $box = $(this).closest('.SP-loadMore');
        const $wrap = $box.children('.toggleWrapper');
        const $plus = $wrap.find('.toggleBtn');
        const $minus = $wrap.find('.toggleInline');

        $box.removeClass('is-expanded');
        $minus.attr('aria-expanded', 'false').prop('hidden', true).hide();
        $plus.attr('aria-expanded', 'false').prop('hidden', false).show();
      });
  }

  function initSpLoadMoreToggle(selector, options) {
    const opts = $.extend({ openLabel: '続きを読む', closeLabel: '閉じる' }, options || {});
    const $boxes = $(selector);
    if (!$boxes.length) return;

    // 現在の幅で初期化／破棄
    if (isMobile()) {
      $boxes.each(function () { initOne($(this), opts); });
    } else {
      $boxes.each(function () { destroyOne($(this)); });
    }

    // リサイズ（メディアクエリアップデート）で再判定
    // matchMedia の change を優先し、フォールバックで resize も登録
    if (mq && typeof mq.addEventListener === 'function') {
      mq.removeEventListener('change', spLoadMoreReflow);
      mq.addEventListener('change', spLoadMoreReflow);
    } else {
      // 古環境向け
      let t = null;
      $(win).off('resize' + NAMESPACE).on('resize' + NAMESPACE, function () {
        clearTimeout(t);
        t = setTimeout(spLoadMoreReflow, 120);
      });
    }

    function spLoadMoreReflow() {
      if (isMobile()) {
        $boxes.each(function () {
          const $box = $(this);
          if (!$box.data('sp-loadmore-initialized')) initOne($box, opts);
        });
      } else {
        $boxes.each(function () {
          const $box = $(this);
          if ($box.data('sp-loadmore-initialized')) destroyOne($box);
        });
      }
    }

    // 外部から状態同期したい場合
    win.spLoadMoreToggle = win.spLoadMoreToggle || {};
    win.spLoadMoreToggle.refresh = spLoadMoreReflow;
  }

  // 起動
  $(function () {
    bindHandlers();
    initSpLoadMoreToggle('.SP-loadMore');
  });

  // グローバル公開
  win.initSpLoadMoreToggle = initSpLoadMoreToggle;

})(window, window.jQuery);

